import axios from 'axios';

export default {
  sendEmail(data) {
    return axios.post('/v1/help-center/send-email', data);
  },
  getAll(params = {}) {
    return axios.get('/v1/faqs/list', { params });
  },
  detailFaq(id) {
    return axios.get(`/v1/faqs/detail/${id}`);
  },
  createFaq(data) {
    return axios.post('/v1/faqs', data);
  },
  editFaq(id, data) {
    return axios.patch(`/v1/faqs/${id}`, data);
  },
  deleteFaq(id) {
    return axios.delete(`/v1/faqs/${id}`);
  },
  faqList(params = {}) {
    return axios.get('/v1/faqs', { params });
  }
};
